/**
 * Gets the most significant entitlement from an array of entitlements
 * based on hierarchy: premium-plus > premium > premium-with-ads
 */
export const getMostSignificantEntitlement = (entitlements: string[]) => {
  if (entitlements.includes('sl_premium_plus')) {
    return 'premium-plus';
  }

  if (entitlements.includes('sl_premium') || entitlements.includes('sl_youth')) {
    return 'premium';
  }

  if (entitlements.includes('sl_premium_ads')) {
    return 'premium-with-ads';
  }

  if (entitlements.includes('sl_forecast_only')) {
    return 'forecast-only';
  }

  return null;
};

export default getMostSignificantEntitlement;
